
import { List } from 'phosphor-react';
import styled from 'styled-components';
import { styleSheet } from '../../assets/styles/global';

export const MainHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: flex-end; /* Align content to right since breadcrumb is gone */
  width: 100%;
  padding: 1rem 2rem;
`;

export const AvatarImage = styled.img`
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  object-fit: cover;
`;

export const UserContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  cursor: pointer;
`;

export const UserName = styled.span`
  font-size: 1.7rem;
  margin-right: 1.5rem;
`;




export const DropdownUsername = styled.span`
  font-family: ${styleSheet.mainFont};
  color: #fff;
  font-weight: 600;
`;

export const MenuIcon = styled(List)`
  cursor: pointer;
  color: #54278b; /* Purple on Mobile */

  @media (min-width: 768px) {
    color: #ffffff; /* White on Desktop */
  }
`;